import { call, put } from 'redux-saga/effects';
import Http from '../../../libs/Http';

export function* fetchBitcoinTradesData(action) {
  const { payload, meta } = action;
  yield put({ $global: true, type: 'START_LOADER' });

  const data = yield call(Http.get, '/jobs/data', {
    query: {}
  });
  yield put({
    type: 'SET_BITCOIN_TRADES_DATA',
    payload: data
  });

  yield put({ $global: true, type: 'STOP_LOADER' });
}

export default function* ({ takeFirst, takeLatest, takeEvery }) {
  yield [
    takeFirst('FETCH_BITCOIN_TRADES_DATA', fetchBitcoinTradesData),
  ];
}



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/BitcoinTrades/BitcoinTrades.sagas.js